import { useMutation } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';

export const useToggleSave = (userId) => {
  return useMutation({
    mutationFn: async ({ recId, isSaved }) => {
      if (!userId || !recId) return { error: new Error('Missing user or recommendation ID') };

      if (isSaved) {
        const { error } = await supabase
          .from('user_recommendations')
          .delete()
          .eq('user_id', userId)
          .eq('recommendation_id', recId);
        return { error };
      } else {
        const { error } = await supabase
          .from('user_recommendations')
          .insert({ user_id: userId, recommendation_id: recId });
        return { error };
      }
    },
  });
};
